{
  "title": "نقاط الذكاء الاصطناعي",
  "description": "كل طلب للذكاء الاصطناعي يستهلك نقاطًا من رصيد السيرفر، ويتجدد رصيد كل سيرفر أول كل شهر.",
  "credits_zero": "0 نقطة",
  "credits_one": "نقطة واحدة",
  "credits_two": "نقطتان",
  "credits_few": "{{n}} نقاط",
  "credits_many": "{{n}} نقطة",
  "credits_other": "{{n}} نقطة",
  "tabs": {
    "label": "أقسام نقاط الذكاء الاصطناعي",
    "overview": "نظرة عامة",
    "usage": "سجل الاستهلاك",
    "settings": "الشحن والحدود"
  },
  "tasks": {
    "simple_question": "سؤال بسيط",
    "explain_error": "شرح خطأ",
    "diagnose_downtime": "تشخيص توقف موقع",
    "fix_config": "إصلاح إعداد",
    "investigation": "فحص معقّد"
  },
  "costs": {
    "fixed_zero": "مجاني",
    "fixed_one": "نقطة واحدة",
    "fixed_two": "نقطتان",
    "fixed_few": "{{n}} نقاط",
    "fixed_many": "{{n}} نقطة",
    "fixed_other": "{{n}} نقطة",
    "range": "من {{min}} إلى {{max}} نقطة",
    "metered": "حسب الاستهلاك، بحد أقصى تحدده"
  },
  "actors": {
    "member": "عضو في الفريق",
    "hosting_account": "حساب استضافة",
    "automation": "تلقائي"
  },
  "automations": {
    "downtime-monitor": "مراقبة التوقف"
  },
  "trial": {
    "title": "رصيد التجربة",
    "body": "خلال التجربة تحصل على رصيد باقة {{plan}} كاملًا: {{credits}} نقطة حتى {{date}}."
  },
  "totals": {
    "left": "النقاط المتبقية هذا الشهر، كل السيرفرات",
    "resets": "يتجدد الرصيد",
    "resetsHint": "النقاط المشتراة تبقى حتى تستخدمها.",
    "autoTopUp": "الشحن التلقائي",
    "autoOn": "مفعّل",
    "autoOff": "متوقف",
    "autoSpent": "هذا الشهر:",
    "autoSetup": "فعّل الشحن التلقائي"
  },
  "servers": {
    "title": "حسب السيرفر",
    "left": "المتبقي",
    "trialAllowance": "رصيد التجربة",
    "trial": "تجربة",
    "low": "استخدمت {{pct}}. اشترِ حزمة أو فعّل الشحن التلقائي حتى لا يتوقف الذكاء الاصطناعي.",
    "out": "نفدت النقاط. طلبات الذكاء الاصطناعي على هذا السيرفر متوقفة حتى تشتري نقاطًا أو يتجدد الرصيد.",
    "notActive": "تبدأ مزايا الذكاء الاصطناعي عند تفعيل السيرفر.",
    "paused": "مزايا الذكاء الاصطناعي متوقفة على هذا السيرفر لأنه لم يتصل بـ bPanel منذ مدة.",
    "resets": "يتجدد في",
    "trialEnds": "تنتهي التجربة",
    "cap": "حد الفحص المعقّد",
    "capValue": "{{n}} نقطة",
    "capCustom": "مخصص",
    "viewUsage": "عرض الاستهلاك",
    "empty": {
      "title": "لا توجد سيرفرات بعد",
      "body": "كل سيرفر يشمل رصيدًا شهريًا من نقاط الذكاء الاصطناعي.",
      "action": "إضافة سيرفر"
    },
    "lowAuto": "استخدمت {{pct}}. يشتري الشحن التلقائي نقاطًا عندما يقل الرصيد عن 10٪.",
    "lowPaused": "استخدمت {{pct}}. الشحن التلقائي متوقف على هذا السيرفر حتى تُسدَّد الدفعة التي تعذّر تحصيلها.",
    "locked": "مزايا الذكاء الاصطناعي متوقفة لأن لوحة التحكم مقفلة. جدّد الاشتراك لتعود، ونقاطك المتبقية محفوظة."
  },
  "usage": {
    "title": "الاستهلاك حسب المهمة",
    "description": "من {{from}} إلى {{to}}، مع التكلفة المعلنة لكل مهمة.",
    "server": "السيرفر",
    "allServers": "كل السيرفرات",
    "requests_zero": "بدون طلبات",
    "requests_one": "طلب واحد",
    "requests_two": "طلبان",
    "requests_few": "{{n}} طلبات",
    "requests_many": "{{n}} طلب",
    "requests_other": "{{n}} طلب",
    "total": "الإجمالي هذا الشهر",
    "costsNote": "السؤال البسيط وشرح الخطأ بنقطة واحدة. الفحص المعقّد حسب الاستهلاك ويتوقف عند الحد الذي تحدده.",
    "daily": "النقاط في اليوم، هذا الشهر",
    "monthly": "النقاط شهريًا",
    "view": "عرض الرسم",
    "days": "أيام",
    "months": "أشهر",
    "noHistory": "لا توجد أشهر سابقة.",
    "chartHint": "مرّر المؤشر على العمود لترى إجماليه."
  },
  "purchases": {
    "title": "آخر المشتريات",
    "description": "حزم من 100 نقطة، تشتريها بنفسك أو عبر الشحن التلقائي.",
    "auto": "شحن تلقائي",
    "manual": "اشتراها عضو في الفريق",
    "states": {
      "processing": "قيد المعالجة",
      "paid": "مدفوعة",
      "failed": "فشلت",
      "refunded": "مستردة",
      "void": "ملغاة",
      "pending": "بانتظار الدفع"
    },
    "empty": {
      "title": "لا توجد مشتريات بعد",
      "body": "تظهر هنا حزم النقاط التي تشتريها مع فواتيرها."
    }
  },
  "buy": {
    "action": "شراء نقاط",
    "title": "اشترِ نقاط ذكاء اصطناعي",
    "description": "تُباع النقاط في حزم من {{size}} نقطة لسيرفر واحد، وتبقى حتى تستخدمها.",
    "server": "السيرفر",
    "serverHint": "المتبقي على السيرفر: {{left}} نقطة",
    "packs": "عدد الحزم",
    "credits_zero": "0 نقطة",
    "credits_one": "نقطة واحدة",
    "credits_two": "نقطتان",
    "credits_few": "{{n}} نقاط",
    "credits_many": "{{n}} نقطة",
    "credits_other": "{{n}} نقطة",
    "unit": "حزمة {{size}} نقطة بسعر اليوم",
    "price": "السعر بدون الضريبة",
    "note": "سعر الحزمة يُطبَّق على كل شراء جديد، والحزم التي اشتريتها سابقًا تبقى بالسعر الذي دفعته.",
    "continue": "متابعة",
    "noServers": "تحتاج إلى سيرفر يعمل لتشتري نقاطًا.",
    "notNow": "ليس الآن",
    "withVat": "الإجمالي شامل الضريبة {{rate}}",
    "noVat": "الإجمالي، بدون ضريبة خارج السعودية"
  },
  "log": {
    "caption": "سجل استهلاك الذكاء الاصطناعي",
    "search": "ابحث في الموضوع",
    "cols": {
      "date": "التاريخ",
      "task": "المهمة",
      "server": "السيرفر",
      "actor": "الطلب من",
      "credits": "النقاط"
    },
    "filters": {
      "server": "السيرفر",
      "task": "المهمة"
    },
    "spentOfCap": "{{spent}} من {{cap}}",
    "running": "قيد التنفيذ",
    "stopped": "توقف عند الحد",
    "export": "تصدير CSV",
    "exported_zero": "لا توجد صفوف للتصدير",
    "exported_one": "تم تصدير صف واحد",
    "exported_two": "تم تصدير صفين",
    "exported_few": "تم تصدير {{n}} صفوف",
    "exported_many": "تم تصدير {{n}} صفًا",
    "exported_other": "تم تصدير {{n}} صف",
    "note": "يعرض طلبات هذا الشهر. إجماليات الأشهر السابقة في صفحة النظرة العامة.",
    "empty": {
      "title": "لا توجد طلبات ذكاء اصطناعي هذا الشهر",
      "body": "تظهر هنا طلبات فريقك وحسابات الاستضافة والفحوصات التلقائية."
    }
  },
  "settings": {
    "save": "حفظ",
    "discard": "تراجع",
    "saved": "تم حفظ إعدادات النقاط",
    "topUp": {
      "title": "الشحن التلقائي",
      "description": "نشتري حزمًا تلقائيًا حتى لا يتوقف الذكاء الاصطناعي في منتصف الشهر.",
      "enable": "اشحن تلقائيًا",
      "rule": "عندما يقل رصيد سيرفر عن {{pct}} من رصيده الشهري، نشتري له {{credits}} نقطة بطريقة الدفع الافتراضية.",
      "packs": "عدد الحزم كل مرة",
      "packsHint": "الحزمة {{size}} نقطة",
      "exclVat": "بدون الضريبة",
      "limit": "الحد الشهري",
      "limitHint": "أقصى مبلغ يصرفه الشحن التلقائي في الشهر، بدون الضريبة. من 5 إلى 2,000.",
      "sar": "ريال سعودي",
      "spent": "المصروف هذا الشهر:",
      "noMethod": "يحتاج الشحن التلقائي إلى طريقة دفع محفوظة، وتُحفظ مع أول دفعة.",
      "readOnly": "تعديل الشحن التلقائي متاح للمالك والمدير وعضو الفوترة فقط."
    },
    "caps": {
      "title": "حد الفحص المعقّد",
      "description": "الفحص المعقّد يُحسب حسب الاستهلاك، ويتوقف عند الحد الذي تحدده لكل مهمة.",
      "default": "الحد الافتراضي",
      "defaultHint": "لكل سيرفر لم تحدد له حدًا خاصًا. من 10 إلى 5,000 نقطة.",
      "unit": "نقطة",
      "perServer": "لكل سيرفر",
      "perServerHint": "اترك الخانة فارغة ليستخدم السيرفر الحد الافتراضي.",
      "serverLabel": "الحد لـ {{server}}",
      "usesDefault": "الافتراضي ({{n}})",
      "readOnly": "تعديل حد الفحص متاح للمالك والمدير وعضو الفوترة فقط."
    }
  }
}
